import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Globe, Menu, X } from 'lucide-react';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { label: 'Startseite', path: '/' },
    { label: 'Anbieter', path: '/anbieter' },
    { label: 'Ratgeber', path: '/ratgeber' },
    { label: 'Für Provider', path: '/fuer-provider' },
  ];

  const isProviderArea = location.pathname.startsWith('/provider');
  const providerLabel = isProviderArea ? 'Portal' : 'Provider-Login';

  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur border-b border-slate-200" data-testid="main-header">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group" data-testid="logo-link">
            <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-sky-500 to-blue-600 flex items-center justify-center">
              <Globe className="w-5 h-5 text-white" />
            </div>
            <div className="hidden sm:block">
              <span className="font-semibold text-lg text-slate-900" style={{fontFamily: 'Space Grotesk, sans-serif'}}>Domain-</span>
              <span className="font-semibold text-lg text-sky-600" style={{fontFamily: 'Space Grotesk, sans-serif'}}>Preischeck</span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-1">
            {navItems.map(item => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === item.path
                    ? 'text-sky-600 bg-sky-50'
                    : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
                }`}
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to={isProviderArea ? '/provider/dashboard' : '/provider/login'}
              className="px-4 py-2 rounded-lg text-sm font-medium text-white bg-gradient-to-r from-sky-500 to-blue-600 hover:from-sky-600 hover:to-blue-700 transition-colors"
              data-testid="nav-provider-login"
            >
              {providerLabel}
            </Link>
          </nav>

          {/* Mobile Menu Toggle */}
          <button
            className="md:hidden p-2 rounded-lg hover:bg-slate-100"
            onClick={() => setMenuOpen(!menuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {menuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>

        {/* Mobile Nav */}
        {menuOpen && (
          <nav className="md:hidden pb-4 border-t border-slate-100 pt-2">
            {navItems.map(item => (
              <Link
                key={item.path}
                to={item.path}
                className="block px-4 py-2 text-sm text-slate-600 hover:text-slate-900 hover:bg-slate-50 rounded-lg"
                onClick={() => setMenuOpen(false)}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to={isProviderArea ? '/provider/dashboard' : '/provider/login'}
              className="block px-4 py-2 text-sm font-medium text-sky-600 hover:bg-sky-50 rounded-lg"
              onClick={() => setMenuOpen(false)}
            >
              {providerLabel}
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
}
